"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButton = void 0;
var lodash_1 = require("lodash");
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var styleUtilities_1 = require("../../../util/styleUtilities");
var Button_style_1 = __importDefault(require("./Button.style"));
function useButton(_a) {
    var icon = _a.icon, isDisabled = _a.isDisabled, isLoading = _a.isLoading, variant = _a.variant, width = _a.width, url = _a.url, onClick = _a.onClick, stopPropagation = _a.stopPropagation, expanded = _a.expanded;
    var component = url ? 'div' : 'button';
    var withIcon = !!icon || !!isLoading;
    var classes = (0, Button_style_1.default)({ width: width, component: component, withIcon: withIcon, isExpandable: expanded !== undefined, isLoading: isLoading });
    var textVariants = ['text', 'textDark'];
    var variantClass = (function () {
        switch (variant) {
            case 'primary':
                return classes.primaryVariant;
            case 'secondary':
                return classes.secondaryVariant;
            case 'text':
                return classes.textVariant;
            case 'alert':
                return classes.alertVariant;
            case 'textDark':
                return classes.textDarkVariant;
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(variant);
        }
    })();
    function getColor(text) {
        if (text === void 0) { text = true; }
        var color = (function () {
            if (variant === 'textDark') {
                return theme_1.default.colors.dark;
            }
            return ['primary', 'alert'].includes(variant) ? '#ffffff' : theme_1.default.colors.primary;
        })();
        return (!isLoading && isDisabled) || (isLoading && text) ? (0, styleUtilities_1.withOpacity)(color, 0.5) : color;
    }
    function handleClick(event) {
        stopPropagation && event.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
    return {
        classes: __assign(__assign({}, (0, lodash_1.omit)(classes, 'primaryVariant', 'secondaryVariant', 'textVariant', 'alertVariant', 'textDarkVariant')), { variant: variantClass }),
        textColor: getColor(true),
        iconColor: getColor(false),
        disabled: isDisabled || isLoading,
        component: component,
        handleClick: handleClick,
        isTextVariant: textVariants.includes(variant),
    };
}
exports.useButton = useButton;
var logic = {
    useButton: useButton,
};
exports.default = logic;
